import {useEffect} from 'react'
import {DataObjectId} from 'yougile-model'
import {useForceUpdate} from '@containers/hooks'
import {idTasksApi, idTasksStore} from '@extensions/id-tasks/id-tasks-store'

export const useIdTask = (taskId: DataObjectId): string | undefined => {
  const forceUpdate = useForceUpdate()

  const idTask = idTasksApi.getIdTask(taskId)

  useEffect(() => {
    forceUpdate()
  }, [idTasksStore.state.modified])

  return idTask
}
